var EBrandImageSchemas;
(function (EBrandImageSchemas) {
    EBrandImageSchemas["DEFAULT"] = "default";
    EBrandImageSchemas["NEGATIVE"] = "negative";
    EBrandImageSchemas["POSITIVE"] = "positive";
})(EBrandImageSchemas || (EBrandImageSchemas = {}));
var EBrandImageLogos;
(function (EBrandImageLogos) {
    EBrandImageLogos["ASSET_PRIMARY"] = "asset-primary";
    EBrandImageLogos["ASSET_SECONDARY"] = "asset-secondary";
    EBrandImageLogos["ASSET_TERTIARY"] = "asset-terciary";
    EBrandImageLogos["ATLAS_PRIMARY"] = "atlas-primary";
    EBrandImageLogos["ATLAS_SECONDARY"] = "atlas-secondary";
    EBrandImageLogos["ATLAS_TERTIARY"] = "atlas-terciary";
    EBrandImageLogos["EDU_PRIMARY"] = "educacao-primary";
    EBrandImageLogos["EDU_SECONDARY"] = "educacao-secondary";
    EBrandImageLogos["EDU_TERTIARY"] = "edu-terciary";
    EBrandImageLogos["PRO_PRIMARY"] = "pro-primary";
    EBrandImageLogos["PRO_SECONDARY"] = "pro-secondary";
    EBrandImageLogos["PRO_TERTIARY"] = "pro-terciary";
    EBrandImageLogos["RENA_PRIMARY"] = "rena-primary";
    EBrandImageLogos["RENA_SECONDARY"] = "rena-secondary";
    EBrandImageLogos["RENA_TERTIARY"] = "rena-terciary";
    EBrandImageLogos["VITRA_PRIMARY"] = "vitra-primary";
    EBrandImageLogos["VITRA_SECONDARY"] = "vitra-secondary";
    EBrandImageLogos["VITRA_TERTIARY"] = "vitra-terciary";
    EBrandImageLogos["WARREN_PRIMARY"] = "warren-primary";
    EBrandImageLogos["WARREN_SECONDARY"] = "warren-secondary";
    EBrandImageLogos["SYMBOL_PRIMARY"] = "symbol-primary";
})(EBrandImageLogos || (EBrandImageLogos = {}));

export { EBrandImageLogos, EBrandImageSchemas };
//# sourceMappingURL=types.js.map
